import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchAssets(ctx, queryParams) {
            if(!queryParams.assetTypeId) queryParams.assetTypeId = ''
            if(!queryParams.assetBrandId) queryParams.assetBrandId = ''
            if(!queryParams.assetGroupId) queryParams.assetGroupId = ''
            if(!queryParams.assetModelId) queryParams.assetModelId = ''

            var qs = ''
            if (queryParams.customerId === undefined) queryParams.customerId = ''
            if (queryParams.sortBy === undefined) queryParams.sortBy = ''


            if (queryParams.workStatusList && queryParams.workStatusList.length > 0) {
                queryParams.workStatusList.map(status => {
                    qs += `&WorkStatusList=${status.name}`
                })

            }

            if (queryParams.sortDesc !== undefined && queryParams.sortDesc == false) {
                queryParams.sortDesc = 'asc'
            } else queryParams.sortDesc = 'desc'

            
            return new Promise((resolve, reject) => {

                axios
                    //.get('/apps/asset/assets', { params: queryParams })
                    .get(`/api/v1/Asset/search?Search=${queryParams.q}&OrdinationField=${queryParams.sortBy}&OrdinationType=${queryParams.sortDesc}&CustomerId=${queryParams.customerId}&AssetTypeId=${queryParams.assetTypeId}&AssetBrandId=${queryParams.assetBrandId}&AssetGroup=${queryParams.assetGroupId}&AssetModelId=${queryParams.assetModelId}&Page=${queryParams.page}&PerPage=${queryParams.perPage}${qs}`)
                    //.get(`/api/v1/Asset/search?Page=${queryParams.page}&PerPage=${queryParams.perPage}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchAsset(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    //.get(`/apps/asset/assets/${id}`)
                    .get(`/api/v1/Asset?id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchAssetSummary(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    //.get(`/apps/asset/assets/${id}`)
                    .get(`/api/v1/Asset/summary?Id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addAsset(ctx, assetData) {
            return new Promise((resolve, reject) => {

                let asset = assetData.assetData
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Asset', asset)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateAsset(ctx, assetData) {
            return new Promise((resolve, reject) => {

                let asset = assetData.assetData
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .put('/api/v1/Asset', asset)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteAsset(ctx, { id }) {
            return new Promise((resolve, reject) => {

                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .delete(`/api/v1/Asset?Id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchAssetTelemetryParameters(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    //.get(`/apps/asset/assets/${id}`)
                    .get(`/api/v1/Asset/gettelemetryparameters?id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchAssetTelemetry(ctx, { id, param, dtS, dtE, page }) {

            return new Promise((resolve, reject) => {
                axios
                    //.get(`/apps/asset/assets/${id}`)
                    .get(`/api/v1/Telemetry/search?AssetId=${id}&Parameter=${param}&Start=${dtS}&End=${dtE}&Page=${page}&PerPage=100`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchAssetWorkstatusHistory(ctx, { id, dt }) {

            return new Promise((resolve, reject) => {
                axios
                    //.get(`/apps/asset/assets/${id}`)
                    .get(`/api/v1/queries/telemetry/workstatushistory?AssetId=${id}&Day=${dt}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchCustomers(ctx, queryParams) {

            return new Promise((resolve, reject) => {

                axios
                    //.get('/apps/asset/assets', { params: queryParams })
                    .get(`/api/v1/Customer/search?Search=${queryParams.q}&Page=1&PerPage=5`)
                    //.get(`/api/v1/Asset/search?Page=${queryParams.page}&PerPage=${queryParams.perPage}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchCustomer(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    //.get(`/apps/user/users/${id}`)
                    .get(`/api/v1/Customer?id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchAssetsManufacture(ctx, page = 1) {

            return new Promise((resolve, reject) => {

                axios
                    //.get('/apps/asset/assets', { params: queryParams })
                    .get(`/api/v1/Asset/searchmanufacturer?Page=${page}&PerPage=100`)
                    ///api/v1/Asset/searchmanufacturer?Page=1&PerPage=10
                    //.get(`/api/v1/Asset/search?Page=${queryParams.page}&PerPage=${queryParams.perPage}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchTypesWorkStatus() {
            return new Promise((resolve, reject) => {

                axios
                    .get(`/api/v1/Asset/searchworkstatus`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchAssetsModel(ctx, { id, page, search = '', perPage = 100 }) {

            return new Promise((resolve, reject) => {

                axios
                    .get(`/api/v1/Asset/searchmodel?ManufacturerId=${id}&Page=${page}&PerPage=${perPage}&Search=${search}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchAssetsType(ctx,) {

            return new Promise((resolve, reject) => {

                axios
                    //.get('/apps/asset/assets', { params: queryParams })
                    .get(`/api/v1/Asset/searchtype`)
                    ///api/v1/Asset/searchmanufacturer?Page=1&PerPage=10
                    //.get(`/api/v1/Asset/search?Page=${queryParams.page}&PerPage=${queryParams.perPage}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchFences(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    //.get('/apps/user/users', { params: queryParams })
                    .get(`/api/v1/VirtualFence/search?Search=${queryParams.q}&Page=${queryParams.page}&PerPage=${queryParams.perPage}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchFence(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    //.get(`/apps/user/users/${id}`)
                    .get(`/api/v1/VirtualFence?id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteFence(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .delete(`/api/v1/VirtualFence?Id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchPoints(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    //.get('/apps/user/users', { params: queryParams })
                    .get(`/api/v1/PointOfInterest/search?Search=${queryParams.q}&Page=${queryParams.page}&PerPage=${queryParams.perPage}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchPoint(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    //.get(`/apps/user/users/${id}`)
                    .get(`/api/v1/PointOfInterest?id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deletePoint(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .delete(`/api/v1/PointOfInterest?Id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchAlarms(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    //.get(`/apps/user/users/${id}`)
                    .get(`/api/v1/Asset/eventgenerator/search?AssetId=${id}&Page=1&PerPage=100`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addMoveAlarm(ctx, alarm) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Asset/eventgenerator/move', alarm)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addAlarmWeekendMove(ctx, alarm) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Asset/eventgenerator/weekendmove', alarm)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addIgnitionAlarm(ctx, alarm) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Asset/eventgenerator/ignition', alarm)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addSevereAlarm(ctx, alarm) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Asset/eventgenerator/severeuse', alarm)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addIddleAlarm(ctx, alarm) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Asset/eventgenerator/iddleuse', alarm)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteAlarm(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .delete(`/api/v1/Asset/eventgenerator?Id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        exportAssetsExcel(ctx, queryParams) {
            if(!queryParams.assetTypeId) queryParams.assetTypeId = ''
            if(!queryParams.assetBrandId) queryParams.assetBrandId = ''
            if(!queryParams.assetGroupId) queryParams.assetGroupId = ''
            if(!queryParams.assetModelId) queryParams.assetModelId = ''

            var qs = ''
            if (queryParams.customerId === undefined) queryParams.customerId = ''
            if (queryParams.sortBy === undefined) queryParams.sortBy = ''


            if (queryParams.workStatusList && queryParams.workStatusList.length > 0) {
                queryParams.workStatusList.map(status => {
                    qs += `&WorkStatusList=${status.name}`
                })

            }

            if (queryParams.sortDesc !== undefined && queryParams.sortDesc == false) {
                queryParams.sortDesc = 'asc'
            } else queryParams.sortDesc = 'desc'
            
            return new Promise((resolve, reject) => {
                axios({
                    url: `api/v1/queries/telemetry/ExportAssetsExcel?Search=${queryParams.q}&OrdinationField=${queryParams.sortBy}&OrdinationType=${queryParams.sortDesc}&CustomerId=${queryParams.customerId}&AssetTypeId=${queryParams.assetTypeId}&AssetBrandId=${queryParams.assetBrandId}&AssetGroup=${queryParams.assetGroupId}&AssetModelId=${queryParams.assetModelId}&Page=${queryParams.page}&PerPage=${queryParams.perPage}${qs}`,
                    method: 'GET',
                    responseType: 'blob', // important
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        exportAssetsPDF(ctx, queryParams = {}) {
            if(!queryParams.assetTypeId) queryParams.assetTypeId = ''
            if(!queryParams.assetBrandId) queryParams.assetBrandId = ''
            if(!queryParams.assetGroupId) queryParams.assetGroupId = ''
            if(!queryParams.assetModelId) queryParams.assetModelId = ''
            
            if (queryParams.q === undefined) queryParams.q = ''
            if (queryParams.customerId === undefined) queryParams.customerId = ''
            if (queryParams.sortBy === undefined) queryParams.sortBy = ''

            var qs = ''
            if (queryParams.workStatusList && queryParams.workStatusList.length > 0) {
                queryParams.workStatusList.map(status => {
                    qs += `&WorkStatusList=${status.name}`
                })
            }

            if (queryParams.sortDesc !== undefined && queryParams.sortDesc == false) {
                queryParams.sortDesc = 'asc'
            } else queryParams.sortDesc = 'desc'

            return new Promise((resolve, reject) => {
                axios({
                    url: `api/v1/queries/telemetry/ExportAssetsPdf?Search=${queryParams.q}&OrdinationField=${queryParams.sortBy}&OrdinationType=${queryParams.sortDesc}&CustomerId=${queryParams.customerId}&AssetTypeId=${queryParams.assetTypeId}&AssetBrandId=${queryParams.assetBrandId}&AssetGroup=${queryParams.assetGroupId}&AssetModelId=${queryParams.assetModelId}${qs}`,
                    method: 'GET',
                    responseType: 'blob', // important
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        fetchDevices(ctx, queryParams) {

            return new Promise((resolve, reject) => {
                axios
                    //.get('/apps/device/devices', { params: queryParams })
                    .get(`/api/v1/device/search?Search=${queryParams.q}&Page=${queryParams.page}&PerPage=${queryParams.perPage}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        sendDeviceTelecommand(ctx, command) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/v1/Device/SendDeviceTelecommand', command)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        sendBulkDeviceTelecommand(ctx, command) {

            return new Promise((resolve, reject) => {
                axios
                    .post('/api/v1/Device/SendBulkDeviceTelecommand', command)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        fetchAllAssetsManufacture(ctx, { page = 1, allData = [] }) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/v1/Asset/searchmanufacturer?Page=${page}&PerPage=100`)
                    .then(response => {
                        const newData = response.data.data;
                        const combinedData = allData.concat(newData);

                        if (newData.length > 0) {
                            ctx.dispatch('fetchAllAssetsManufacture', { page: page + 1, allData: combinedData })
                                .then(resolve) // Continua passando a promessa resolvida
                                .catch(reject);
                        } else {
                            resolve({ data: { data: combinedData } });
                        }
                    })
                    .catch(reject);
            });
        },

        fetchAllAssetsModel(ctx, { id = '', page = 1, allData = [] }) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/v1/Asset/searchmodel?ManufacturerId=${id}&Page=${page}&PerPage=100`)
                    .then(response => {
                        const newData = response.data.data;
                        const combinedData = allData.concat(newData);

                        // Se a API retornou resultados nesta página, busca a próxima
                        if (newData && newData.length > 0) {
                            ctx.dispatch('fetchAllAssetsModel', { id: id, page: page + 1, allData: combinedData })
                                .then(resolve) // Continua passando a promessa resolvida
                                .catch(reject);
                        } else {
                            // Se não há mais resultados, retorna todos os dados combinados
                            resolve({ data: { data: combinedData } });
                        }
                    })
                    .catch(reject);
            });
        },

        // Buscar todos os ativos recursivamente com filtros (para Safe Spot)
        fetchAllAssetsForSafeSpot(ctx, { assetSearch = '', assetId, page = 1, allData = [] }) {
            return new Promise((resolve, reject) => {
                const queryParams = {
                    q: assetSearch || '',
                    sortBy: '',
                    sortDesc: 'desc',
                    customerId: '',
                    assetTypeId: '',
                    assetBrandId: '',
                    page,
                    perPage: 100,
                    workStatusList: []
                };

                ctx.dispatch('fetchAssets', queryParams)
                    .then(response => {
                        const newData = response.data.data || [];
                        
                        // Filtrar apenas campos necessários
                        let filteredData = newData.map(asset => ({
                            id: asset.id,
                            manufacturerName: asset.manufacturerName,
                            model: asset.model,
                            modelName: asset.modelName,
                            plate: asset.plate,
                            chassisNumber: asset.chassis,
                            nickName: asset.nickname,
                            lastLat: asset.lastLat,
                            lastLng: asset.lastLng,
                            lastWorkstatus: asset.lastWorkstatus,
                            lastPositionTime: asset.lastPositionTime,
                            iconUrl: asset.iconUrl || '',
                            assetType: asset.assetType
                        }));

                        if (assetId) {
                            filteredData = filteredData.filter(asset => String(asset.id) === String(assetId))
                        }

                        const combinedData = allData.concat(filteredData);
                        const totalItems = response.data.totalItems || 0;

                        // Se assetSearch foi informado, não fazer paginação (retornar apenas primeira página)
                        // Se há mais dados para buscar e não é busca por texto específico
                        if (!assetSearch && combinedData.length < totalItems && filteredData.length === 100) {
                            ctx.dispatch('fetchAllAssetsForSafeSpot', {
                                assetSearch,
                                assetId,
                                page: page + 1,
                                allData: combinedData
                            })
                            .then(resolve)
                            .catch(reject);
                        } else {
                            resolve({ data: combinedData });
                        }
                    })
                    .catch(reject);
            });
        },

        fetchAssetSummaryParameter(ctx, { assetId }) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/v1/Asset/SearchAssetSummaryParameter?AssetId=${assetId}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            });
        },

        fetchWeatherForecast(ctx, { lat, lng, days }) {
            const apiKey = 'af231b220b6f4782afd144147260801'; 
            const baseUrl = 'https://api.weatherapi.com/v1';
        
            return new Promise((resolve, reject) => {
                axios
                    .get(`${baseUrl}/forecast.json?key=${apiKey}&q=${lat},${lng}&days=${days}&lang=pt`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchAssetViewPort(ctx, queryParams ) {
            const {
                search,
                northLat,
                southLat,
                westLng,
                eastLng,
                zoom,
                customerId,
                assetTypeId,
                assetBrandId,
                assetModelId
            } = queryParams;
            
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/Asset/searchviewport`, {
                        params: {
                            search,
                            northLat,
                            southLat,
                            westLng,
                            eastLng,
                            zoom,
                            customerId,
                            assetTypeId,
                            assetBrandId,
                            assetModelId
                        }
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        fetchAssetsBoundingBox(ctx, queryParams ) {
            const {
                search = '',
                customerId,
                assetTypeId,
                assetBrandId,
                assetModelId
            } = queryParams;

            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/Asset/GetAssetsBoundingBox`, {
                        params: {
                            search,
                            ownerId: customerId,
                            assetTypeId,
                            assetBrandId,
                            assetModelId
                        }
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        cloneAsset(ctx, id) {
            return new Promise((resolve, reject) => {

                
                axios
                    .post('/api/v1/Asset/CloneAsset', {id: id})
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        fetchAssetsChangeLog(ctx, queryParams ) {
            const {
                search,
                userId,
                assetId,
                startDate,
                endDate,
                page,
                perPage,
            } = queryParams;

            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/Asset/SearchAssetChangeLog`, {
                        params: {
                            search,
                            userId,
                            assetId,
                            startDate,
                            endDate,
                            page,
                            perPage,
                        }
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },


    },
}